import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TransferReceive from './TransferReceive';
import TransferChangeLocation from './TransferChangeLocation';

/**
 * A component for displaying Button components for Transfers.
 *
 */
class TransferButtons extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: {},
            activateReceive: true,
            activateChange: true
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.record !== this.props.record) {
            this.setState({
                record: nextProps.record
            });
        }
    }

    handleActivateReceiveComponent = (e) => {
        this.setState({
            activateChange: !e
        });
    };

    handleActivateChangeComponent = (e) => {
        this.setState({
            activateReceive: !e
        });
    };

    handleReceiveTransferEvent = (e) => {
        //console.log('receive event: ', e);
    };

    handleChangeLocationEvent = (e) => {
        //console.log('change location event: ', e);
    };

    render() {
        return (
            <div>
                <TransferReceive
                    record={this.props.record}
                    onActivateComponent={this.handleActivateReceiveComponent}
                    onClickReceive={this.handleReceiveTransferEvent}
                    position="left"
                    basePath={this.props.basePath}
                    showComponent={this.state.activateReceive}
                />
                <TransferChangeLocation
                    record={this.props.record}
                    onActivateComponent={this.handleActivateChangeComponent}
                    onClickChangeLocation={this.handleChangeLocationEvent}
                    position="right"
                    basePath={this.props.basePath}
                    showComponent={this.state.activateChange}
                />
            </div>
        )
    }
}

TransferButtons.propTypes = {
    addField: PropTypes.bool,
    record: PropTypes.object,
};

TransferButtons.defaultProps = {
    addField: true,
};

export default TransferButtons;


// WEBPACK FOOTER //
// ./src/Fuse/components/TransferButtons.js